module.exports = __webpack_public_path__ + "img/red.1abb0e5a.png";